import React from 'react';
import { CCard, CCardBody, CCardHeader, CRow, CCol } from '@coreui/react';
import Nav from '../../CreatorComponents/Nav';
import CustomersWidget from '../../CreatorComponents/CustomersWidget';

const Customers = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Nav />
      <div style={{ padding: '20px' }}>
        <CCard className="mb-4">
          <CCardHeader style={{ 
            backgroundColor: '#187da0', 
            color: 'white',
            padding: '20px'
          }}>
            <h1 style={{ margin: 0, fontSize: '24px' }}>Customers</h1>
          </CCardHeader>
          <CCardBody>
            <div style={{ padding: '16px' }}>
              <CRow className="mb-4">
                <CCol md={6}>
                  <CustomersWidget />
                </CCol>
              </CRow>

              <h2 style={{ fontSize: '20px', marginBottom: '16px' }}>Customer List</h2>
              <div className="customer-list">
                {/* Customer list content will go here */}
                <p>Customer list coming soon...</p>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </div>
  );
};

export default Customers; 